<mat-card>
  <form [formGroup]="lineOfBusinessFormGroup" (ngSubmit)="submitForm()">
    <mat-card-content>

    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button type="submit">Save</button>
    </mat-card-actions>
  </form>
</mat-card>